<template>

  <section>

    <div class="container is-fluid">

      <div class="columns is-multiline">

        <div
          class="column is-full"
          v-for="listing in $store.state.property.listings"
          :key="listing.id"
        >

          <section
            class="card moveable-card"
            :class="{ 'has-text-grey-light': !listing.isActive, 'has-background-white-bis': !listing.isActive }"
          >
            <div class="card-content">

              <article class="media">

                <figure class="media-left">
                  <p
                    class="image is-square is-128x128 is-size-7"
                    v-if="listing.pictureUrls.length > 0"
                  >
                    <img :src="listing.pictureUrls[0]">
                  </p>
                  <p
                    class="image is-128x128"
                    v-if="listing.pictureUrls.length <= 0"
                  >
                    <img src="
                    https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg">
                  </p>
                  <p class="is-size-7">{{ listing.pictureUrls.length }} pictures<br>{{ listing.updated | fromNow }}</p>
                </figure>

                <div class="media-content">

                  <div class="level is-marginless is-size-7">
                    <div
                      v-if="listing.isActive"
                      style="color: green"
                    >
                      <i class="far fa-play-circle"></i>
                      ACTIVE
                    </div>
                    <div
                      v-if="!listing.isActive"
                      style="color: red"
                    >
                      <i class="far fa-stop-circle"></i>
                      INACTIVE
                    </div>
                  </div>

                  <div class="level is-marginless">
                    <div class="has-text-weight-semibold">
                      {{ listing.title }}
                    </div>
                  </div>

                  <div class="level is-marginless">
                    <div>
                      Available {{ listing.availableDate | dateMedium }}
                    </div>
                  </div>

                  <div class="level is-marginless">
                    <div>
                      Rent {{ listing.rentPolicy }}
                    </div>
                  </div>

                  <div class="level is-marginless">
                    <div>
                      Deposit {{ listing.depositPolicy }}
                    </div>
                  </div>

                  <div class="level is-marginless is-size-7">
                    <div>
                      Public link
                      <a
                        :href="listing.publicLink"
                        target="_blank"
                      >{{ listing.publicLink }}</a>
                    </div>
                  </div>

                  <div class="level">
                    <div class="level-left">

                      <div class="level-item">
                        <span class="link">
                          <b-tooltip
                            label="Edit"
                            position="is-bottom"
                          >
                            <a
                              class="fas fa-edit"
                              @click="editListing(listing)"
                            ></a>
                          </b-tooltip>
                        </span>
                      </div>

                    </div>
                  </div>

                </div>

              </article>

            </div>

          </section>

        </div>

      </div>

    </div>

    <b-modal
      :active.sync="$store.state.listing.isPublicLinkActive"
      has-modal-card
    >
      <PublicLink />
    </b-modal>

  </section>

</template>

<script>
import Helpers from "@/services/Helpers.js";
import PublicLink from "@/components/properties/listings/PublicLink.vue";

export default {
  components: { Helpers, PublicLink },

  props: { propertyId: String },

  data() {
    return {
      note: ""
    };
  },

  methods: {
    editListing(listing) {
      console.log("editListing()", listing);
      this.$store.state.listing.attributes = { ...listing };
      this.$store.state.listing.attributes.availableDate = new Date(
        this.$store.state.listing.attributes.availableDate
      );
      this.$store.state.listing.isNew = false;
      this.$store.state.listing.isActive = true;
    },

    publicLink(listing) {
      console.log("publicLink()", listing);
      this.$store.state.listing.attributes = { ...listing };
      this.$store.state.listing.isPublicLinkActive = true;
    }
  },

  mounted() {
    console.log("mounted()");
  }
};
</script>

<style>
</style>
